import React from 'react';
import { motion } from 'framer-motion';

const StatsSection = ({ stats }) => {
    if (!stats || stats.length === 0) return null;

    return (
        <section className="py-16 md:py-24 bg-white relative overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 items-center">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={stat.id || index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                delay: index * 0.1,
                                duration: 0.8,
                                ease: [0.22, 1, 0.36, 1]
                            }}
                            className="flex flex-col items-center lg:items-start group"
                        >
                            <div className="flex items-baseline gap-1 mb-2">
                                <h3 className="text-5xl md:text-7xl font-serif text-agro-black group-hover:text-agro-green transition-colors duration-500">
                                    {stat.value}
                                </h3>
                                {stat.value.includes('+') ? null : <span className="text-3xl text-agro-lime font-serif">+</span>}
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="w-8 h-px bg-agro-lime"></span>
                                <p className="text-gray-400 font-sans text-xs md:text-sm tracking-[0.2em] uppercase font-black">
                                    {stat.label}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-100 to-transparent"></div>
        </section>
    );
};

export default StatsSection;
